<template>
  <div class="w-100 search_filters-mobile-wrapper"
    :style="{ zIndex: isShowFilter ? '3' : '2' }"
  >
    <div class="mt-0 mb-2 w-100 bg-grey">
      <button class="btn btn-primary px-3 w-100" @click="toggleFilter" :disabled="!isInitSearchLoaded && !isFilterLoaded">
        <i class="fa fa-filter mr-2"></i>Open Filters & Analytics
      </button>
    </div>

    <div v-if="isShowFilter" class="search_filters-mobile d-flex flex-column h-100">
      <div class="d-flex justify-content-between py-2 px-3 bd-b">
        <span class="t-600">Filters & Analytics</span>
        <a v-if="hasActiveBucket" @click.stop @click.prevent="$emit('resetFilters')" href="#" class="t-secondary t-sm">
          clear all filters
        </a>
      </div>
      <div class="bg-white flex-grow-1 scrollable">
        <template v-if="!isScopedSearch && Object.values(filterSets).length > 0">
          <single-filter :filter="filterSets"
            :key="'quick_filters'"
            :filterName="'quick_filters'"
            :isFilterLoaded="isFilterLoaded"
            :isFilterSetLoaded="isFilterSetLoaded"
            :state="state"
            :isMobileFilter="true"
            :canViewFilters="canViewFilters"
            :canUseFilters="canUseFilters"
            class="bd-none mb-2"
            @filterCollapseToggled="handleCollapseToggled"
            @bucketToggled="handleBucketToggled"
            @setToggled="handleSetToggled"
            @bucketDateToggled="handleBucketDateToggled"
            @bucketSinceToggled="handleBucketSinceToggled"
            @bucketAdded="handleBucketAdded"
            @bucketShowAll="handleBucketShowAll"
          />
        </template>
        <template v-for="(filterSections, sectionName) in sectionedFilters">
          <div class="search_filters-mobile-sections" :key="sectionName">
            <div class="d-flex justify-content-between px-3">
              <span class="t-600">{{ sectionName | humanize }}</span>
              <a
                @click.prevent="toggleSection(sectionName)"
                class="t-sm t-secondary" href="#"
                v-if="canViewFilters"
              >{{ areAllFiltersInSectionOpen(filterSections) ? 'close' : 'open' }}</a>
            </div>
            <template v-for="filter in filterSections">
              <single-filter :filter="filter"
                v-if="!filter.hide"
                :key="filter.name"
                :filterName="filter.name"
                :isFilterLoaded="isFilterLoaded"
                :isFilterSetLoaded="isFilterSetLoaded"
                :state="state"
                :isMobileFilter="true"
                :canViewFilters="canViewFilters"
                :canUseFilters="canUseFilters"
                @filterCollapseToggled="handleCollapseToggled"
                @bucketToggled="handleBucketToggled"
                @setToggled="handleSetToggled"
                @bucketDateToggled="handleBucketDateToggled"
                @bucketSinceToggled="handleBucketSinceToggled"
                @bucketAdded="handleBucketAdded"
                @bucketShowAll="handleBucketShowAll"
              />
            </template>
          </div>
        </template>
      </div>
      <div class="bg-white py-1 px-3 bd-t">
        <button @click="toggleFilter" class="btn btn-form btn-secondary width--100per t-700">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import sharedFilter from '@/mixins/search/filters'
import SingleFilter from '@/components/search/filter/Filter'

export default {
  name: 'FiltersMobile',
  mixins: [sharedFilter],
  data () {
    return {
      isShowFilter: false
    }
  },
  components: {
    SingleFilter
  },
  methods: {
    toggleFilter () {
      this.isShowFilter = !this.isShowFilter
      this.isShowFilter ? document.body.classList.add('modal-open-mobile') : document.body.classList.remove('modal-open-mobile')
    }
  },
  destroyed () {
    document.body.classList.remove('modal-open-mobile')
  }
}
</script>
